import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaHeart } from "react-icons/fa6";
import "./Whishlist.css";
import CommonFooter from "../../components/footer/CommonFooter";
import ProductCard from "../home/components/ProductCard";
import { appApiHandler } from "../../api/appApiHandler";
import { setWhishlist } from "../../store/slices/whishlistState";
import FullScreenLoader from "../../components/loader/fullScreenLoader/FullscreenLoader";
import HomeHeader from "../../components/header/HomeHeader";
import { setWhishlistCount } from "../../store/slices/countState";
import EmptyState from "../../components/EmptyState";
import Breadcrumb from "../../components/breadcrumb";
import { FaUser } from "react-icons/fa";

const Wishlist = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { whishlist } = useSelector((state) => state.whishlistState);
  const { userData } = useSelector((state) => state.userState);
  const { isLoggedIn } = useSelector((state) => state.authState);

  const [loading, setLoading] = useState(false);
  const [wishlistLoading, setWishlistLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const getProducts = async () => {
    const reqData = {
      user_id: userData?._id,
    };
    const response = await appApiHandler.getWishlist(reqData);
    if (response?.status === 200 && response?.data) {
      setProducts(response?.data);
      dispatch(setWhishlist(response?.data));
      dispatch(setWhishlistCount(response?.data?.length));
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isLoggedIn && userData?._id) {
      setLoading(true);
      getProducts();
    }
  }, [isLoggedIn, userData?._id]);

  useEffect(() => {
    if (whishlist && isLoggedIn) {
      setProducts(whishlist);
    }
  }, [whishlist, isLoggedIn]);

  const renderProducts = useCallback(
    (item) => {
      return (
        <ProductCard
          key={item?.product?._id}
          item={item?.product}
          singleImage
          setWishlistLoading={setWishlistLoading}
        />
      );
    },
    [products]
  );

  return (
    <div className="wishlistPage">
      {/* <HomeHeader /> */}
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          {
            label: "My Wishlist",
            isActive: true,
          },
        ]}
      />
      {!isLoggedIn ? (
        <EmptyState
          icon={FaUser}
          title="Sign In to Continue"
          description="Please login with your account. Enjoy a seamless shopping experience with personalized recommendations and more!"
          buttonText="Login"
          onButtonClick={() => navigate("/login")}
          iconSize={48}
        />
      ) : loading ? (
        <div className="wishlistPage__loading">
          <FullScreenLoader text="Loading wishlist..." />
        </div>
      ) : products?.length > 0 ? (
        <main className="wishlistPage__main">
          <section className="wishlistPage__content">
            <div className="wishlistPage__list">
              {products?.map((item) => renderProducts(item))}
            </div>
          </section>
        </main>
      ) : (
        <EmptyState
          icon={FaHeart}
          title="Your wishlist is empty"
          description="Start adding products to your wishlist by browsing our collection."
          buttonText="Browse Products"
          onButtonClick={() => navigate("/")}
          iconSize={64}
        />
      )}

      <CommonFooter />
      {wishlistLoading && <FullScreenLoader text="Updating wishlist..." />}
    </div>
  );
};

export default Wishlist;
